import React, { useState } from 'react'
import ReactTable from 'react-table'
import { Query } from 'react-apollo'
import { useMutation } from '@apollo/react-hooks'
import _ from 'lodash'
import moment from 'moment'
import FileDownload from 'js-file-download'
import axios from 'axios'
import {
  Modal,
  Radio,
  DatePicker,
  message,
} from 'antd'
import {
  Div, H3, Loading, P, DynamicButtonLink, Button,
} from 'konsys-ui'
import config from './config'
import { theme } from '../../../styles/_variables'
import { Wrapper } from '../../../components/mechanics-components'
import { GET_MECHANICS } from '../../../constants/graphql/query'
import { SYNC_MECH_SALARY } from '../../../constants/graphql/mutation'
import { getAccessToken, getURL } from '../../../utils/local-data-service'
import './style-css.css'
import PERMISSION from '../../../constants/permissions'

const { color } = theme

// const download = (setIsLoading) => {
//   axios({
//     method: 'GET',
//     responseType: 'blob',
//     headers: {
//       Authorization: `Bearer ${getAccessToken()}`,
//     },
//     url: `${getURL().FILE_SERVER}/download/gasstation`,
//   }).then((resp) => {
//     FileDownload(resp.data, `ข้อมูลสถานีเติมน้ำมัน วันที่ ${moment().format('DD')} ${monthConverter(moment().format('MM'))} ${parseInt(moment().format('YYYY'), 10) + 543}.xls`)
//     setIsLoading(false)
//   })
// }

const downloadSalary = (setSalaryLoading) => {
  axios({
    method: 'GET',
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
    url: `${getURL().FILE_SERVER}/download/excel/mechanic/salary`,
  }).then((resp) => {
    FileDownload(resp.data, `รายงานเงินเดือนช่าง ณ วันที่ ${moment().format('YYYY-MM-DD')}.xlsx`)
    setSalaryLoading(false)
  })
}

const ExportSalaryModal = ({
  exportSalaryModal, setExportSalaryModal, isLoading, setIsLoading,
}) => {
  const [month, setMonth] = useState()
  const [period, setPeriod] = useState()
  return (
    <Modal
      title="เลือกวันที่เริ่ม-สิ้นสุด"
      visible={exportSalaryModal}
      onCancel={() => {
        setExportSalaryModal(false)
        setMonth()
        setPeriod()
      }}
      onOk={() => {
        setIsLoading(true)
        axios({
          method: 'GET',
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          url: `${getURL().FILE_SERVER}/download/excel/mechanic/salary?startDate=${period === 1 ? moment(month).startOf('month').format('YYYY-MM-DD') : moment(month).set('date', 16).format('YYYY-MM-DD')}&endDate=${period === 1 ? moment(month).set('date', 15).format('YYYY-MM-DD') : moment(month).endOf('month').format('YYYY-MM-DD')}`,
        }).then((resp) => {
          FileDownload(resp.data, `รายงานเงินเดือนช่าง ณ วันที่ ${period === 1 ? moment(month).startOf('month').format('YYYY-MM-DD') : moment(month).set('date', 16).format('YYYY-MM-DD')} - ${period === 1 ? moment(month).set('date', 15).format('YYYY-MM-DD') : moment(month).endOf('month').format('YYYY-MM-DD')}.xlsx`)
          setIsLoading(false)
          setMonth()
          setPeriod()
        })
      }}
      destroyOnClose={true}
      okButtonProps={{
        disabled: _.isUndefined(month) || _.isUndefined(period) || isLoading,
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='column'>
        <DatePicker.MonthPicker placeholder='เลือกเดือน' onChange={(e) => {
          setMonth(e)
        }} style={{ width: '100%' }} />
        <Radio.Group style={{ width: 'fit-content', margin: '24px 0 0 0' }} onChange={(e) => {
          setPeriod(e.target.value)
        }} value={period}>
          <Radio.Button value={1}>งวดที่1</Radio.Button>
          <Radio.Button value={2}>งวดที่2</Radio.Button>
        </Radio.Group>
      </Div>
    </Modal>
  )
}

const SyncModal = ({
  syncModal, setSyncModal,
}) => {
  const [month, setMonth] = useState()
  const [doAction, { loading }] = useMutation(SYNC_MECH_SALARY)
  return (
    <Modal
      title="เลือกเดือน"
      visible={syncModal}
      destroyOnClose={true}
      onCancel={() => {
        setSyncModal(false)
        setMonth()
      }}
      onOk={() => {
        doAction({
          variables: { month },
        }).then(({ data }) => {
          const resp = data.SyncMechanicSalary
          if (resp.success) {
            message.success(resp.message)
            setMonth()
            setSyncModal(false)
          } else message.error(resp.message)
        })
      }}
      okButtonProps={{
        disabled: loading || _.isUndefined(month),
        loading,
      }}
      cancelButtonProps={{
        disabled: loading,
      }}
    >
      <Div alignItems='center' display='flex' flexDirection='row' justifyContent='space-between'>
        <P margin = '0 32px 0 0'>เลือกเดือน</P>
        <DatePicker.MonthPicker
          format='MM/YYYY'
          onChange={(e) => {
            setMonth(e)
          }}
        />
      </Div>
    </Modal>
  )
}

const Index = () => {
  const [salaryLoading, setSalaryLoading] = useState(false)
  const [exportSalaryModal, setExportSalaryModal] = useState(false)
  const [syncModal, setSyncModal] = useState(false)
  return (
  <Div display='flex' flexDirection='column'>
    <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
      <H3 bold color={color.primaryColor} margin='32px 0'>รายชื่อช่าง</H3>
      <Div display='flex' flexDirection='row' justifyContent='space-between'>
        <Button
          text='บันทึกเงินเดือนในPEAK'
          onClick={() => {
            setSyncModal(true)
          }}
          margin='0 16px 0 0'
        />
        <Button
            text='พิมพ์รายงานเงินเดือนช่าง'
            icon='fas fa-print'
            disabled={salaryLoading}
            onClick={() => {
              setExportSalaryModal(true)
            }}
            margin='0 16px 0 0'
          />
        <DynamicButtonLink link='/mechanic/add' condition={_.includes(window.perms, PERMISSION.CREATE_MECHANIC)} props={{ text: 'เพิ่มช่าง' }}/>
      </Div>
    </Div>
    <List/>
    <SyncModal syncModal={syncModal} setSyncModal={setSyncModal}/>
    <ExportSalaryModal exportSalaryModal={exportSalaryModal} setExportSalaryModal={setExportSalaryModal} isLoading={salaryLoading} setIsLoading={setSalaryLoading} />
  </Div>
  )
}

export const List = () => {
  const [filtered, setFiltered] = useState()
  const [sorted, setSorted] = useState([{ id: 'id', desc: false }])
  const [current, setCurrent] = useState(0)
  return (
    <Wrapper overflow padding='0 0 40px 0'>
      <Query
        query={GET_MECHANICS}
        fetchPolicy='cache-and-network'
        variables={{
          limit: 5,
          offset: current * 5,
          orderBy: sorted[0].desc ? 'DESC' : 'ASC',
          orderField: sorted[0].id,
          ...filtered,
        }}
      >{({ data, loading, error }) => {
        if (loading && _.isEmpty(data)) return <Loading center='true' />
        if (error) return <P>เกิดข้อผิดพลาด</P>
        return (
          <Div>
            <ReactTable
              className='table'
              data={data.MechanicList.lists} // *
              resizable={false}
              columns={config.columns} // *
              minRows={5}
              manual
              // defaultPageSize={10}
              showPageSizeOptions={false}
              getTdProps={() => ({ disabled: true })} // *
              getTrProps={(state, rowInfo) => { // *
                if (rowInfo) {
                  return {
                    style: {
                      padding: '8px 0',
                      backgroundColor: '#ffffff',
                      borderLeft: `3px solid ${color.primaryColor}`,
                    },
                  }
                } return {}
              }}
              previousText='ก่อนหน้า'
              nextText='ถัดไป'
              pageText='หน้า'
              ofText='จาก'
              page={current}
              pages={Math.ceil(data.MechanicList.totalFilter / 5)}
              onPageChange={page => setCurrent(page)}
              onFilteredChange={async (newFiltered) => {
                const newOjb = {}
                await newFiltered.forEach((v) => {
                  Object.assign(newOjb, { [v.id]: v.value })
                })
                setFiltered(newOjb)
                setCurrent(0)
              }}
              onSortedChange={async (newSorted) => {
                setSorted(newSorted)
                setCurrent(0)
              }}
            />
            {
              loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
            }
          </Div>
        )
      }}
      </Query>

    </Wrapper>
  )
}
export default Index
